import React, { useState } from 'react'
import styled from 'styled-components'

import NoDataValue from 'pages/HehmDevice/HehmDashboard/NoDataValue'
import ProductLiteratureSearchModal from 'pages/Device/SystemComponentsPanel/ProductLiteratureSearchModal'
import Table from 'components/Table'

import { color } from 'styles/colors'

import HehmDevice, { HehmDeviceHardware } from 'types/HehmDevice'
import { screenSize } from 'styles/shared'

type Props = {
  hehmDevice: HehmDevice | null
  hehmDeviceHardware: HehmDeviceHardware | null
}

const ComponentsTable = ({ hehmDevice, hehmDeviceHardware }: Props) => {
  const [showProductLiteratureModal, setShowProductLiteratureModal] = useState(false)

  const connectionStatus = () => {
    if (hehmDevice?.connectionStatus?.connected === undefined) {
      return null
    } else if (hehmDevice?.connectionStatus?.connected === true) {
      return 'Connected'
    } else {
      return 'Disconnected'
    }
  }

  return (
    <>
      <S.Table>
        <S.TableHeader>
          <S.TableHeaderCell title="Description" />
          <S.TableHeaderCell title="Model Number" />
          <S.TableHeaderCell title="Serial Number" />
          <S.TableHeaderCell title="Firmware Version" />
          <S.TableHeaderCell title="Device Status" />
          <S.TableHeaderCell title="Warranty Status" />
        </S.TableHeader>

        <S.TableRow>
          <S.ComponentCell>
            <S.Icon src={'/img/hehm_sys_comp.png'} alt="equipment" />
            HVAC Performance Monitoring Kit
          </S.ComponentCell>

          {hehmDeviceHardware?.moduleInfo?.partNumber ? (
            <S.ModelNumberCell onClick={() => setShowProductLiteratureModal(true)}>
              {hehmDeviceHardware.moduleInfo.partNumber}
            </S.ModelNumberCell>
          ) : (
            <S.ComponentCell>
              <NoDataValue />
            </S.ComponentCell>
          )}

          <S.ComponentCell>
            {hehmDeviceHardware?.moduleInfo?.serialNumber || <NoDataValue />}
          </S.ComponentCell>

          <S.FirmwareVersionCell>
            <S.FirmwareVersion>
              <S.FirmwareLabel>EMHKT</S.FirmwareLabel>
              <S.FirmwareValue>{
                hehmDeviceHardware?.modem?.firmwareVersion ||
                <NoDataValue />
              }
              </S.FirmwareValue>
            </S.FirmwareVersion>
            <S.FirmwareVersion>
              <S.FirmwareLabel>OD</S.FirmwareLabel>
              <S.FirmwareValue>{
                hehmDeviceHardware?.outdoorModule?.firmwareVersion ||
                <NoDataValue />
              }
              </S.FirmwareValue>
            </S.FirmwareVersion>
            <S.FirmwareVersion>
              <S.FirmwareLabel>ID</S.FirmwareLabel>
              <S.FirmwareValue>{
                hehmDeviceHardware?.indoorModule?.firmwareVersion ||
                <NoDataValue />
              }
              </S.FirmwareValue>
            </S.FirmwareVersion>
          </S.FirmwareVersionCell>

          <S.ComponentCell>
            {connectionStatus() || <NoDataValue />}
          </S.ComponentCell>

          <S.ComponentCell>
            <NoDataValue />{/* Placeholder for warranty status */}
          </S.ComponentCell>
        </S.TableRow>
      </S.Table>

      {hehmDeviceHardware?.moduleInfo?.partNumber && (
        <ProductLiteratureSearchModal
          closeCallback={() => setShowProductLiteratureModal(false)}
          modelNumber={hehmDeviceHardware?.moduleInfo?.partNumber || ''}
          isDisplayed={showProductLiteratureModal}
        />
      )}
    </>
  )
}

export default ComponentsTable

const componentCellStyle = `
  padding: 15px;

  @media ${screenSize.medium} {
    padding: 10px 0 0 15px ;
  }
`

const S = {
  Table: styled(Table)`
    border: 1px solid ${color('border')};
    border-radius: 20px;
  `,
  ComponentCell: styled(Table.Cell)`
    ${componentCellStyle}

  `,
  ModelNumberCell: styled(Table.Cell)`
    ${componentCellStyle}

    color: ${color('anchor')};
    cursor: pointer;

  `,
  FirmwareVersionCell: styled(Table.Cell)`
    ${componentCellStyle}

    display: flex;
    flex-direction: column;
    gap: 4px;

  `,
  FirmwareVersion: styled.div`
    display: grid;
    grid-template-columns: 45% 1fr;
  `,
  FirmwareLabel: styled.span``,
  FirmwareValue: styled.span`
  
  @media ${screenSize.medium} {
    padding-left: 7px;
  } 
  `,
  Icon: styled.img`
    width: 26px;
    height: 26px;
    margin: 0px 8px 0 0;

   @media ${screenSize.medium} {
      width: 24px;
      height: 24px;
    }
  `,
  TableHeaderCell: styled(Table.HeaderCell)`
    &:first-child {
      border-top-left-radius: 18px;
    }
    &:last-child {
      border-top-right-radius: 18px;
    }
  `,
  TableRow: styled(Table.Row)`
      align-items: flex-start;
      border-bottom: none;

      @media ${screenSize.medium} {
        flex-direction: column;
        padding: 15px 0;
      }
  `,
  TableHeader: styled(Table.Header)`
    @media ${screenSize.medium} {
        display: none;
      }
  `
}
